import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../orders/orderdetail/order-detail-order-only.css';

const SessionExpiredModal: React.FC = () => {
  const { login } = useAuth();

  return (
    <div
      className="order-detail-check-slack-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-message"
    >
      <div className="order-detail-check-slack-dialog">
        <p id="session-expired-message" className="order-detail-check-slack-message">
          Your session expired. Sign in again to keep working.
        </p>
        <button
          type="button"
          className="order-detail-check-slack-btn"
          onClick={() => login()}
        >
          Sign in again
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
